import {
  SubscriptionCycle,
  SubscriptionCycleOperators,
  SubscriptionFrequency,
  SubscriptionType,
} from 'typings'
import { messages } from './messages'
import { IntlShape } from 'react-intl'

export function formatType(type: SubscriptionType, intl: IntlShape): string {
  const { $t } = intl

  return $t(messages.type[type].label)
}

export function formatFrequency(
  frequency: SubscriptionFrequency | undefined,
  intl: IntlShape
): string {
  if (!frequency) return ''

  const { $t } = intl

  const { value, unit } = frequency

  const formatUnit = () => {
    return $t(messages.view.frequency.unit[unit], { amount: value })
  }

  return $t(messages.view.detail.frequency, {
    value,
    unit: formatUnit(),
  })
}

export function formatCycle(
  cycle: SubscriptionCycle | undefined,
  intl: IntlShape
): string {
  if (!cycle) return ''

  const { $t } = intl

  const { operator } = cycle

  switch (operator) {
    case SubscriptionCycleOperators.RANGE:
      return $t(messages.view.cycle.range, {
        min: cycle.min,
        max: cycle.max,
      })
    default:
      return $t(messages.view.cycle[operator], {
        value: cycle.value,
      })
  }
}

export function formatSubscription(values: string[], intl: IntlShape): string {
  const { formatList } = intl

  const processedValues: string[] = values
    .filter((value) => value.length)
    .map((value, index) => (index === 0 ? value : value.toLowerCase()))

  return formatList(processedValues)
}
